module.exports = __webpack_public_path__ + "static/gallery-5@2x-8ea6210be00d91a363b644dc634b7e9c.jpg";